import React from 'react'
import './Header.scss'

const Header: React.FC = () => {
    return (
        <div className='header'>
            <h3>Simi Swaminathan</h3>
        </div>
    )
}
export default Header